import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon/ListItemIcon';
import ListItemText from '@mui/material/ListItemText/ListItemText';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import MuiDrawer from '@mui/material/Drawer/Drawer';
import InventoryIcon from '@mui/icons-material/Inventory';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { drawerWidth } from '../../config/consts';
import { ListItemButton, styled } from '@mui/material';

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const AppDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  })
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  backgroundColor: theme.palette.primary.main,
  ...theme.mixins.toolbar,
}));

export default function Drawer({ open, setOpen }) {
  const location = useLocation();
  const routeIsActive = (path) => location.pathname.includes(path);

  return (
    <AppDrawer
      variant="permanent"
      open={open}
      onClose={() => setOpen(false)}
      anchor="left"
      sx={{ display: { xs: 'none', md: 'block' } }}
    >
      <DrawerHeader sx={{ boxShadow: 4 }} />
      <Divider />
      <List>
        {menuItems.map(({ name, icon, path }) => (
          <NavLink key={name} to={path} style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton key={name} selected={routeIsActive(path)}>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={name} />
            </ListItemButton>
          </NavLink>
        ))}
      </List>
    </AppDrawer>
  );
}

const menuItems = [
  {
    name: 'داشبورد',
    icon: <DashboardIcon fontSize="large" />,
    path: '/dashboard',
  },
  {
    name: 'انبارداری',
    icon: <InventoryIcon fontSize="large" />,
    path: '/inventory',
  },
  {
    name: 'فروش',
    icon: <PointOfSaleIcon fontSize="large" />,
    path: '/sales',
  },
];
